// extracted by mini-css-extract-plugin
export var container = "_qw-0";
export var table = "_qw-2";
export var tableWrapper = "_qw-1";